const getProductNameById = (productId, categories) => {
  const product = (categories || []).find((entry) => Number(entry?.id) === Number(productId));

  return product?.x3_productname ?? product?.x3ProductName ?? product?.name ?? product?.code ?? String(productId ?? '');
};

export const getMonthlyPostingProductName = (posting, categories) => {
  const explicitName = posting?.x3ProductName ?? posting?.x3_productname;

  if (explicitName) return explicitName;

  return getProductNameById(posting?.productId, categories);
};

export const getMonthlyPostingFinalizedByUser = (posting) =>
  posting?.createdByUser || posting?.finalizedByUser || posting?.approvedByUser || posting?.postedByUser;

export const getMonthlyPostingFinalizedByDisplayName = (posting, emptyLabel = '—') => {
  const user = getMonthlyPostingFinalizedByUser(posting);

  if (!user) return emptyLabel;

  return `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || emptyLabel;
};
